// measurement-timer.ts
import { timer, Observable } from 'rxjs';

export const measurementTimer = {
  shortDelay(): Observable<number> {
    return timer(100); // For quick refresh (dark/satellite mode re-init)
  },
  mediumDelay(): Observable<number> {
    return timer(200); // For map reinitialization wait
  },
  longDelay(): Observable<number> {
    return timer(300); // For retry after failure
  }
};
